import styled from 'styled-components';
import {IThemeProvider} from '../../../../../../Theme/defaultTheme';

export const PaymentsList = styled.div<IThemeProvider>`
  width: 100%;
  overflow-x: auto;

  display: flex;
  gap: ${props => props.theme.format.main_md_gap};
`;